var React = require('react');

function Swipe (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"160.5","cy":"160.5","r":"160","fill":"white","fillOpacity":"0.5","stroke":"black","key":0}),React.createElement("path",{"d":"M80 160L140 51.7468L140 268.253L80 160Z","fill":"#1e4549","key":1}),React.createElement("path",{"d":"M240 160L180 268.253L180 51.7468L240 160Z","fill":"#1e4549","key":2}),React.createElement("line",{"x1":"160.5","y1":"2.11067e-08","x2":"160.5","y2":"321","stroke":"#1e4549","key":3})]);
}

Swipe.defaultProps = {"width":"321","height":"321","viewBox":"0 0 321 321","fill":"none"};

module.exports = Swipe;

Swipe.default = Swipe;
